import { databaseViewFilterFunctions } from '@streamlain/database-identity';

import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const booleanFilter = [
  createFilter({
    name: 'isChecked',
    self: t.boolean.instance(),
    args: [],
    label: 'Is checked',
    shortString: () => ': Checked',
    impl: databaseViewFilterFunctions.isChecked,
    defaultValue: () => true,
  }),
  createFilter({
    name: 'isUnchecked',
    self: t.boolean.instance(),
    args: [],
    label: 'Is unchecked',
    shortString: () => ': Unchecked',
    impl: databaseViewFilterFunctions.isUnchecked,
    defaultValue: () => false,
  }),
];
